module.exports = __webpack_public_path__ + "img/ori.7579bfb8.png";